<template>
  <div>
    <Accordion
      :Heading="systemConfiguartion"
      :Title1="measurementUnit"
      :Title2="currencyUnitVal"
      :Title3="allowance"
      :Value1="seamUnitDefaultValue"
      :Value2="currencyDefaultValue"
      :Value3="defaultAllowanceVal"
    >
      <div id="users-grid" style="margin-top: -20px">
        <div class="card bg-white mb-3" style="width: 100%; margin-top: 1.3rem; border-radius: 10px">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <label for="unitOfMeasurement">{{ $t("systemConfiguration.seamLengthUnitOfMeasurement") }}</label>
                <div class="input-group mb-3">
                  <div class="input-group mb-3">
                    <kendo-dropdownlist
                      field="dropdownId"
                      ref="dropdownlist"
                      v-if="loaded"
                      :data-source="seamUnitData"
                      :index="seamUnitDefaultValueIndex"
                      @change="onChange"
                      id="seamLengthUnitId"
                    >
                    </kendo-dropdownlist>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <label for="packageUnit">{{ $t("systemConfiguration.packageUnit") }}</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist
                    v-if="loaded"
                    :data-source="packageUnitData"
                    :index="packageUnitDefaultValueIndex"
                    id="packageUnitDataId"
                  >
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-3">
                <label for="currencyUnit">{{ $t("systemConfiguration.currencyUnit") }}</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist
                    v-if="loaded"
                    :data-source="currencyUnitData"
                    :index="currencyDefaultValueIndex"
                    id="currencyUnitId"
                    >INR
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-3">
                <label for="tktTex">{{ $t("systemConfiguration.tktTex") }}</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist
                    v-if="loaded"
                    :data-source="tktTexData"
                    :index="tktTexDefaultValueIndex"
                    id="tktTexId"
                  >
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="customRange3">{{ $t("systemConfiguration.defaultAllowance") }}</label>
                <output style="position: absolute; right: 20px" v-if="loaded">{{ this.defaultAllowanceVal }}%</output>
                <input
                  type="range"
                  class="custom-range"
                  min="0"
                  max="50"
                  step="1"
                  v-if="loaded"
                  :value="defaultAllowanceVal"
                  id="customRange3"
                  oninput="this.previousElementSibling.value = this.value + '%'"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button class="btn btn-sm mt-2" @click="onSave" style="background-color: #0054a6; color: white">
                  {{ $t("systemConfiguration.update") }}
                </button>
              </div>
            </div>
            <div class="coats-divider" v-if="+activeAccountType == 101">
              <span>{{ $t("systemConfiguration.viewMessage") }}</span>
            </div>
            <div class="row" v-if="+activeAccountType == 101">
              <div class="col-12" style="border: 1px solid #e4e4e4; padding: 15px; margin-top: 15px">
                <label for="costFile">{{ $t("systemConfiguration.costFile") }}</label>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>{{ $t("systemConfiguration.name") }}</th>
                      <th>{{ $t("systemConfiguration.lastUpdated") }}</th>
                      <th>{{ $t("systemConfiguration.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ this.costFileName }}</td>
                      <td v-if="loaded" class="ml-6">{{ this.lastUpdatedTime }}</td>
                      <td style="width: 20%">
                        <div class="action" style="display: flex">
                          <div v-if="costFileName != ''">
                            <button
                              @click="downloadCostFile"
                              class="k-button k-button-icontext k-grid-threadUsage"
                              style="color: black; border-radius: 3px; margin-right: 8px; width: 27px; height: 27px"
                            >
                              <span class="k-icon k-i-arrow-down" :title="downloadCompleteCostData"></span>
                            </button>
                          </div>
                          <div>
                            <a
                              class="k-button k-button-icontext k-grid-threadUsage"
                              href="/CostFileTemplate.xls"
                              download
                              style="
                                color: black;
                                border-radius: 3px;
                                margin-right: 8px;
                                width: 27px;
                                height: 27px;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                              "
                            >
                              <span class="k-icon k-i-copy" :title="downloadBlankTemplate"></span>
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <DialogBox v-if="showModal" :jsondata="constFileData" :importType="2" :title="'Data Upload'" />
                <div>
                  <label class="custom-file" style="margin-top: 6px; width: 15%">
                    <label
                      for="exampleInputFile"
                      class="btn btn-sm btn-primary"
                      aria-describedby="fileHelp"
                      style="margin-top: -6px; background-color: #0054a6; color: white"
                      >{{ $t("systemConfiguration.chooseFile") }}</label
                    >
                    <input
                      type="file"
                      id="exampleInputFile"
                      @change="onFileChange"
                      ref="fileToUpload"
                      style="display: none"
                    />
                    <span class="custom-file-control form-control-file"></span>
                  </label>
                </div>

                <div class="calculation-engine-box" v-if="+activeAccountType == 101">
                  <div class="engine-header">
                    <div>
                      <span class="calculation-title">{{ $t("systemConfiguration.calculationEngine") }}</span>
                    </div>
                    <div
                      class="engine-toggle"
                      :class="{ disabled: isEngineToggleDisabled || isCalculationEngineUpdating }"
                    >
                      <button
                        type="button"
                        :class="{ active: calculationEngine === 'Seamworks' }"
                        :disabled="isEngineToggleDisabled || isCalculationEngineUpdating"
                        @click="changeCalculationEngine('Seamworks')"
                      >
                        Seamworks
                      </button>

                      <button
                        type="button"
                        :class="{ active: calculationEngine === 'GSD V4' }"
                        :disabled="isEngineToggleDisabled || isCalculationEngineUpdating"
                        @click="changeCalculationEngine('GSD V4')"
                      >
                        GSD V4
                      </button>
                    </div>
                  </div>

                  <div class="engine-description">
                    {{ $t("systemConfiguration.calculationEngineDescription") }}
                  </div>

                  <div class="engine-current">
                    <span class="info-icon">ⓘ</span>
                    {{ $t("systemConfiguration.calculationEngineCurrentStatus", { engine: calculationEngine }) }}
                  </div>

                  <div v-if="isEngineToggleDisabled" class="engine-locked-message">
                    <span class="k-icon k-i-lock lock-icon"></span>
                    {{ $t("systemConfiguration.calculationEngineLockedMessage", { styleCount: styleCount }) }}
                  </div>
                </div>

                <!-- #143352: tenant-level Multi Component Thread flag, common to both engines. Saves on toggle. -->
                <div
                  class="calculation-engine-box multi-component-thread-box"
                  v-if="+activeAccountType == 101 && showMultiComponentThread"
                >
                  <div class="engine-header">
                    <div>
                      <span class="calculation-title">{{ $t("systemConfiguration.multiComponentThread") }}</span>
                    </div>
                    <toggle-button
                      :value="isMultiComponentThreadEnabled"
                      :disabled="isMultiComponentThreadUpdating"
                      :height="25"
                      :width="60"
                      :checkedText="$t('systemConfiguration.on')"
                      :uncheckedText="$t('systemConfiguration.off')"
                      checkedBg=" #0054a6"
                      uncheckedBg="lightgrey"
                      @click="changeMultiComponentThread(!isMultiComponentThreadEnabled)"
                    ></toggle-button>
                  </div>

                  <div class="engine-description">
                    {{ $t("systemConfiguration.multiComponentThreadDescription") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </Accordion>
    <ShadeGrouping></ShadeGrouping>
    <CustomSetting
      v-if="loaded && !isV4CalculationEngine"
      :seamUnitDefaultValue="seamUnitDefaultValue"
      :seamLengthUnit="seamUnitDefaultValueIndex"
    ></CustomSetting>
  </div>
</template>

<script lang="ts">
import i18n from "@/i18n";
import { Inject } from "inversify-props";
import { UserApi, UserAdminSettingApi, DataImportApi } from "@/api";
import {
  IdentityUserDto,
  IdentityUserDtoPagedResultDto,
  ConfigurationUpdateDto,
  CalculationEngineType
} from "@/api/model";
import BaseGridMixin from "@/core/views/grids/BaseGrid";
import { AxiosResponse } from "axios";
import GridLoading from "@/core/views/pages/_components/GridLoading.vue";
import { read, utils, WorkBook, WorkSheet } from "xlsx";
import DialogBox from "@/app/views/_components/DialogBox.vue";
import { DropDownList } from "@progress/kendo-dropdowns-vue-wrapper";
import moment from "moment";
import { User } from "oidc-client";
import Accordion from "@/app/views/_components/Accordion.vue";
import ShadeGrouping from "./ShadeGrouping.vue";
import CustomSetting from "./CustomSetting.vue";
import { eventBus } from "@/main";
import { Options } from "vue-class-component";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { BAccordion, BAccordionItem } from "bootstrap-vue-next";
import VueToggles from "vue-toggles";

function downloadCsv(data: any, fileName: any) {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.setAttribute("style", "display: none");
  const blob = new Blob([data], { type: "octet/stream" }),
    url = globalThis.URL.createObjectURL(blob);
  a.href = "data:text/csv;charset=utf-16,%EF%BB%BF" + encodeURIComponent(data);
  a.download = fileName;
  a.click();
  globalThis.URL.revokeObjectURL(url);
}

@Options({
  components: {
    GridLoading,
    DialogBox,
    "kendo-dropdownlist": DropDownList,
    Accordion,
    ShadeGrouping,
    CustomSetting,
    BAccordion,
    BAccordionItem,
    "toggle-button": VueToggles
  }
})
export default class SystemConfiguration extends BaseGridMixin<IdentityUserDto, IdentityUserDtoPagedResultDto> {
  toast = useToast();
  store = useStore();
  fields = [
    { key: "email", sortable: true },
    { key: "emailConfirmed", sortable: false },
    { key: "name", sortable: true },
    { key: "userName", sortable: true },
    { key: "lockoutEnabled", sortable: false },
    { key: "lockoutEnd", sortable: false },
    { key: "id", sortable: false, thStyle: { width: "20%" } }
  ];
  meta = {
    formRoute: "SystemUserFormCreate"
  };
  @Inject("UserApi")
  private readonly usersApi!: UserApi;
  @Inject("UserAdminSettingApi")
  private readonly userAdminSettingApi!: UserAdminSettingApi;
  @Inject("DataImportApi")
  private readonly dataImportApi!: DataImportApi;
  showModal = false;
  parse_header = "";
  constFileData = null;
  adminSettings!: any;
  currencyUnitData!: any | null;
  seamUnitData!: any | null;
  packageUnitData!: any | null;
  tktTexData!: any | null;
  loaded = false;
  lastUpdatedTime!: any | null;
  defaultAllowanceVal = 0;
  currencyDefaultValue = "";
  currencyDefaultValueIndex: any;
  tktTexDefaultValue!: any | null;
  tktTexDefaultValueIndex: any;
  seamUnitDefaultValue = "";
  seamUnitDefaultValueIndex: any;
  packageUnitDefaultValue!: any | null;
  packageUnitDefaultValueIndex: any;
  costFileName = "";

  calculationEngine = "Seamworks";
  isCalculationEngineUpdating = false;
  isCalculationEngineReadOnly = false;
  styleCount = 0;

  isMultiComponentThreadEnabled = false;
  isMultiComponentThreadUpdating = false;
  // TEMPORARY: hide in production until development is complete
  showMultiComponentThread = window.location.hostname === "localhost" || window.location.hostname.includes("qa");

  // Computed property for toggle enable/disable rule.
  get isEngineToggleDisabled(): boolean {
    return this.isCalculationEngineReadOnly;
  }

  // calculationEngine holds the display label "GSD V4" (with a space), not the enum name "GsdV4"
  get isV4CalculationEngine(): boolean {
    const engineType = String(this.calculationEngine ?? "")
      .trim()
      .toLowerCase();
    return engineType === "gsd v4";
  }

  systemConfiguartion: any = i18n.global.t("systemConfiguration.systemConfiguartion");
  measurementUnit: any = i18n.global.t("systemConfiguration.measurementUnit");
  currencyUnitVal: any = i18n.global.t("systemConfiguration.currencyUnitVal");
  allowance: any = i18n.global.t("systemConfiguration.allowance");
  downloadCompleteCostData: any = i18n.global.t("systemConfiguration.downloadCompleteCostData");
  downloadBlankTemplate: any = i18n.global.t("systemConfiguration.downloadBlankTemplate");
  onChange(): void {}
  created(): void {
    this.sort.sortBy = "email";
    this.onMountAdminSettings();
    eventBus.emit("pageName", "System Configuration");
  }
  getRequest(
    skipCount?: number,
    maxResultCount?: number,
    sorting?: string
  ): Promise<AxiosResponse<IdentityUserDtoPagedResultDto>> {
    return this.usersApi.apiIdentityUsersGet(undefined, sorting, skipCount, maxResultCount);
  }
  deleteRequest(id: string): Promise<AxiosResponse<void>> {
    return this.usersApi.apiIdentityUsersIdDelete(id);
  }
  public onFileChange(event: Event): any {
    /* wire up file reader */
    const target = event.target as any;
    if (target.files.length !== 1) {
      throw new Error("Cannot use multiple files");
    }
    let name: any = document.getElementById("exampleInputFile") as HTMLInputElement;
    let fileName: string = name.files.item(0).name;
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files?.[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: WorkBook = read(binarystr, { type: "binary" });
      /* selected the first sheet */
      const wsname: string = wb.SheetNames?.[0];
      const ws: WorkSheet = wb.Sheets[wsname];
      const data: any = utils.sheet_to_json(ws, { header: 1, defval: "", blankrows: false }); // to get 2d array pass 2nd parameter as object {header: 1}
      // Data will be logged in array format containing objects
      let rowsData: any = [];
      for (let e of data) {
        let row: any = {};
        let cells: any = [];
        // Iterate over the keys of object
        row["defaultName"] = fileName;
        for (let key of Object.keys(e)) {
          let cell = {
            value: ""
          };
          //Copy the value
          let val = e[key];
          cell.value = val;
          cells.push(cell);
        }
        row["cells"] = cells;
        rowsData.push(row);
      }
      this.constFileData = Object.assign([], rowsData);
      this.showModal = true;
    };
    this.$nextTick(() => {
      this.showModal = false;
      this.constFileData = null;
      (this.$refs.fileToUpload as HTMLFormElement).value = "";
    });
  }
  private currentDateTime(date: any) {
    return moment(date).format("MMMM Do YYYY");
  }
  async onMountAdminSettings(): Promise<void> {
    await this.userAdminSettingApi
      .apiSystemConfigurationGet()
      .then(async e => {
        const configData = e.data;
        this.currencyUnitData = e.data["currencyUnit"]?.all;
        this.seamUnitData = e.data["seamLengthUnit"]?.all;
        this.packageUnitData = e.data["packageUnit"]?.all;
        this.tktTexData = e.data["tktTex"]?.all;
        this.lastUpdatedTime = e.data.lastUpdatedTime;
        this.lastUpdatedTime = this.currentDateTime(this.lastUpdatedTime);
        this.defaultAllowanceVal = e.data.defaultAllowance as number;
        this.loaded = true;

        this.costFileName = configData.costFileName as string;

        //this.calculationEngine = (configData as any)["calculationEngine"] ?? "Seamworks";
        const calculationEngine =
          (configData as any)?.calculationEngineType?.defaultItem ??
          (configData as any)?.CalculationEngineType?.DefaultItem;

        // Normalize to match isV4CalculationEngine; backend persists the enum name ("GsdV4" -> "gsdv4").
        const normalizedEngine = String(calculationEngine ?? "")
          .trim()
          .toLowerCase();
        this.calculationEngine = normalizedEngine === "gsdv4" ? "GSD V4" : "Seamworks";

        this.styleCount = this.toCount((configData as any).styleCount);
        this.isCalculationEngineReadOnly = !!configData.isCalculationEngineReadOnly;
        // Stored as "true"/"false"; a missing row (not yet seeded) is treated as OFF.
        this.isMultiComponentThreadEnabled = configData.multiComponentThread === "true";

        this.currencyDefaultValue = configData["currencyUnit"]?.defaultItem as string;
        this.currencyDefaultValueIndex = this.currencyUnitData.indexOf(this.currencyDefaultValue);
        this.tktTexDefaultValue = e.data["tktTex"]?.defaultItem;
        this.tktTexDefaultValueIndex = this.tktTexData.indexOf(this.tktTexDefaultValue);
        this.seamUnitDefaultValue = e.data["seamLengthUnit"]?.defaultItem as string;
        this.seamUnitDefaultValueIndex = this.seamUnitData.indexOf(this.seamUnitDefaultValue);
        this.packageUnitDefaultValue = e.data["packageUnit"]?.defaultItem;
        this.packageUnitDefaultValueIndex = this.packageUnitData.indexOf(this.packageUnitDefaultValue);
        sessionStorage.setItem("seamLengthUnit", this.seamUnitDefaultValue);
        sessionStorage.setItem("customSettingToggleValue", e.data["customSettingToggleValue"] as string);
      })
      .catch(e => {
        this.toast.error(e.errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      })
      .finally(() => {});
  }
  get activeUser(): User | null {
    return this.store.getters.oidcUser;
  }
  get activeUserName(): string {
    if (this.activeUser as any) {
      return (this.activeUser as any)["given_name"] ?? "";
    }
    return "";
  }
  get activeAccountType(): string {
    if (this.activeUser as any) {
      sessionStorage.setItem("activeUserId", (this.activeUser as any)["cd_account_type"] ?? "");
      return (this.activeUser as any)["cd_account_type"] ?? "";
    }
    return "";
  }
  async onSave(): Promise<void> {
    let defaultAllowanceValue: any = (document.getElementById("customRange3") as HTMLInputElement).value;
    let packageUnitDataValue: any = (document.getElementById("packageUnitDataId") as HTMLInputElement).value;
    let currencyUnitDataValue: any = (document.getElementById("currencyUnitId") as HTMLInputElement).value;
    let tktTexDataValue: any = (document.getElementById("tktTexId") as HTMLInputElement).value;
    let seamLengthUnitDataValue: any = (document.getElementById("seamLengthUnitId") as HTMLInputElement).value;
    const ConfigurationUpdateDto: ConfigurationUpdateDto = {
      seamLengthUnit: seamLengthUnitDataValue,
      packageUnit: packageUnitDataValue,
      currencyUnit: currencyUnitDataValue,
      tktTexUnit: tktTexDataValue,
      defaultAllowance: defaultAllowanceValue
    } as ConfigurationUpdateDto;
    await this.userAdminSettingApi
      .apiUpdateSystemConfigurationPost(ConfigurationUpdateDto)
      .then(() => {
        this.toast.success("Data Saved Successfully", {
          toastClassName: "custom-success-toast",
          timeout: 5000
        });
      })
      .then()
      .catch(e => {
        this.toast.error(e.errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      })
      .finally(() => {
        globalThis.location.reload();
      });
  }

  async changeCalculationEngine(engine: string): Promise<void> {
    // Prevent change if locked/updating/same value
    if (this.isEngineToggleDisabled || this.isCalculationEngineUpdating || this.calculationEngine === engine) {
      return;
    }

    const previousEngine = this.calculationEngine;

    // UI update
    this.calculationEngine = engine;
    this.isCalculationEngineUpdating = true;

    try {
      // Convert UI text -> backend enum value
      const engineValue = engine === "GSD V4" ? CalculationEngineType.GsdV4 : CalculationEngineType.Seamworks;

      // API call
      await this.userAdminSettingApi.apiUpdateCalculationEngineTypePost({
        calculationEngineType: engineValue
      });

      this.toast.success(i18n.global.t("systemConfiguration.calculationEngineUpdateSuccess") as string, {
        toastClassName: "custom-success-toast",
        timeout: 5000
      });
    } catch (e: any) {
      // rollback UI
      this.calculationEngine = previousEngine;

      this.toast.error(
        e?.errorMsg ||
          e?.response?.data?.error?.message ||
          (i18n.global.t("systemConfiguration.calculationEngineUpdateError") as string),
        {
          toastClassName: "custom-error-toast",
          timeout: 5000
        }
      );
    } finally {
      this.isCalculationEngineUpdating = false;
    }
  }

  async changeMultiComponentThread(enabled: boolean): Promise<void> {
    if (this.isMultiComponentThreadUpdating) {
      return;
    }

    const previousValue = this.isMultiComponentThreadEnabled;

    // UI update
    this.isMultiComponentThreadEnabled = enabled;
    this.isMultiComponentThreadUpdating = true;

    try {
      const ConfigurationUpdateDto: ConfigurationUpdateDto = {
        multiComponentThread: String(enabled)
      } as ConfigurationUpdateDto;
      await this.userAdminSettingApi.apiUpdateSystemConfigurationPost(ConfigurationUpdateDto);

      this.toast.success(i18n.global.t("systemConfiguration.multiComponentThreadUpdateSuccess") as string, {
        toastClassName: "custom-success-toast",
        timeout: 5000
      });
    } catch (e: any) {
      // rollback UI
      this.isMultiComponentThreadEnabled = previousValue;

      this.toast.error(
        e?.errorMsg ||
          e?.response?.data?.error?.message ||
          (i18n.global.t("systemConfiguration.multiComponentThreadUpdateError") as string),
        {
          toastClassName: "custom-error-toast",
          timeout: 5000
        }
      );
    } finally {
      this.isMultiComponentThreadUpdating = false;
    }
  }

  private toCount(value: unknown): number {
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
      return 0;
    }

    return parsedValue;
  }

  async downloadCostFile(): Promise<void> {
    await this.dataImportApi
      .apiReportGetCostFileReportGet()
      .then(e => {
        let date = new Date();
        let fileName = "Cost-file-" + date.toDateString();
        downloadCsv(e.data, fileName);
        this.toast.success(this.$t("operationListComp.success") as string, {
          toastClassName: "custom-success-toast",
          timeout: 5000
        });
      })
      .catch(e => {
        this.toast.error(e.errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      })
      .finally(() => {});
  }
}
</script>
<style>
.k-dropdown,
.k-dropdowntree {
  width: 19.4em !important;
}
.k-list-item.k-selected {
  color: #ffffff;
  background-color: #0054a6 !important;
}
:hover.k-state-selected {
  color: #ffffff;
  background-color: #0054a6 !important;
}
.k-list-optionlabel.k-state-selected {
  color: #ffffff;
  background-color: #0054a6 !important;
}

.k-item.k-state-selected {
  color: #ffffff;
  background-color: #0054a6 !important;
}
/* for color */
.k-panelbar .k-state-selected {
  background-color: #0054a6 !important;
}
/* for arrow */
.k-panelbar > .k-item > .k-link.k-state-selected .k-icon {
  color: #ffffff !important;
}
.k-panelbar > .k-item > .k-link .k-icon {
  color: #ffffff !important;
}
/* for not selected */
.k-panelbar > .k-item > .k-link,
.k-panelbar > .k-panelbar-header > .k-link {
  background-color: #0054a6 !important;
  border: 1px solid #0054a6 !important;
  border-radius: 3px !important;
  height: 43px !important;
  margin-top: 17px !important;
}
.k-header {
  margin-bottom: 6px !important;
  font-weight: bold !important;
}
.k-panelbar > .k-item > .k-link.k-state-focused {
  box-shadow: none !important;
}
.k-panelbar {
  border: none !important;
}
.k-window {
  box-shadow: 0 0 10px #000000 !important;
}
.k-window-titlebar {
  border-color: inherit;
  color: #fafafa !important;
  background-color: #0054a6 !important;
}
.b-toaster {
  z-index: 99999 !important;
}
.k-clear-value {
  width: 10px !important;
}
.k-combobox .k-select {
  width: calc(1.4285714286em + 0px) !important;
}
.k-panelbar-item-text {
  width: 100vw !important;
  display: flex !important;
  justify-content: space-between !important;
  padding: 43px 27px 27px 27px !important;
}
.k-grid .k-command-cell > .k-button + .k-button {
  margin-inline-start: 20px !important;
}
.k-grid a {
  width: 23px !important;
  height: 22px !important;
}
.k-grid tr.k-selected > td {
  background-color: #c5def6 !important;
}
.k-checkbox:checked,
.k-checkbox.k-checked {
  border-color: white !important;
  background-color: #c5def6 !important;
}
.k-checkbox:checked:focus,
.k-checkbox.k-checked.k-focus {
  box-shadow: 0 0 0 2px #add2f5;
}
.k-dialog-wrapper .k-dialog {
  overflow: hidden !important;
}
.k-slider .k-slider-selection {
  background-color: #0054a6 !important;
}
.k-slider .k-draghandle {
  border-color: #0054a6 !important;
  color: white;
  background-color: #0054a6 !important;
}
.k-slider.k-focus .k-draghandle {
  box-shadow: 0 0 0 5px #b3c1d0 !important;
}
.k-icon.k-i-x {
  margin-right: 10px !important;
}
.k-grid td {
  padding: 12px 12px;
}
.k-column-title {
  font-weight: bold;
}
.coats-divider {
  text-align: center;
  margin: 24px 0 18px 0;
  border-top: 1px solid #f0d58b;
}

.coats-divider span {
  position: relative;
  top: -12px;
  background: #fff8e1;
  border: 1px solid #f0c45c;
  color: #8a5a00;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.calculation-engine-box {
  border: 1px solid #a8c9f7;
  background: #f8fbff;
  padding: 13px 14px 14px 14px;
  border-radius: 2px;
  margin-top: 18px;
  font-size: 12px;
  color: #1f2937;
}

.multi-component-thread-box {
  border-color: #f0c45c;
  background: #fff8e1;
}

.engine-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.calculation-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.new-badge {
  display: inline-block;
  margin-left: 6px;
  background: #0054a6;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  line-height: 16px;
}

.engine-description {
  margin-top: 11px;
  color: #4b5563;
  line-height: 18px;
  max-width: calc(100% - 230px);
}

.engine-current {
  margin-top: 10px;
  color: #111827;
  font-size: 12px;
}

.info-icon {
  color: #0054a6;
  margin-right: 4px;
}

.engine-toggle {
  display: flex;
  background: #eef2f7;
  border: 1px solid #d8dee8;
  border-radius: 18px;
  padding: 3px;
  width: 190px;
  height: 34px;
}

.engine-toggle button {
  flex: 1;
  border: none;
  background: transparent;
  border-radius: 15px;
  font-size: 12px;
  color: #000000;
  cursor: pointer;
  padding: 5px 14px;
}

.engine-toggle button.active {
  background: #0054a6;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
}

.engine-toggle button:disabled {
  cursor: not-allowed;
}

.engine-toggle.disabled {
  opacity: 1;
}

.engine-locked-message {
  margin-top: 13px;
  background: #fff7f3;
  border: 1px solid #f2b8a0;
  color: #9a3412;
  padding: 8px 11px;
  font-size: 12px;
  border-radius: 2px;
  width: 100%;
}

.lock-icon {
  margin-right: 7px;
}

.preview-link {
  display: inline-block;
  margin-top: 10px;
  color: #334155;
  font-size: 11px;
  text-decoration: underline;
}
</style>
